/* unplugin-vue-components disabled */import script from "./H5HowToPlayBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./H5HowToPlayBanner.vue?vue&type=script&setup=true&lang=js"

import "./H5HowToPlayBanner.vue?vue&type=style&index=0&id=400b2a74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-400b2a74"]])

export default __exports__